import React from "react";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const CompanyExpandLink = ({ id, action }) => {
  const { navigateToCompanyDetail } = useSmartNavigate();

  const handleClick = (e) => {
    e.stopPropagation();
    if (action) {
      navigateToCompanyDetail(id);
    }
  };

  return (
    <a onClick={handleClick}>
      <i className="fas fa-expand-arrows-alt text-lg"></i>
    </a>
  );
};

export default CompanyExpandLink;

